import React from 'react'

// const LOGO_PATH = `${process.env.PUBLIC_URL}/media/logos/city-match/logo.png`
const LOGO_PATH = `${process.env.PUBLIC_URL}${process.env.REACT_APP_ASSET_LOGO}`
const APP_NAME = `${process.env.PUBLIC_URL}${process.env.REACT_APP_APP_NAME}`

const CityMatchLogo = ({height = 'auto'}) => (
  <img className="img-fluid" alt={APP_NAME} src={LOGO_PATH} style={{height}} />
)

export default CityMatchLogo
